/**
 * Calulation functions for chemical curve calculation
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Decimal} from 'decimal.js'

 const sumCalc = (nD: number, parameter_matrix: any[], T: number) => {
    let calc: number = 0.0;
    parameter_matrix.forEach((element: any, i: number) => {
        element.forEach((val: any, j: number) => {

            const valDec = new Decimal(val.value)
            const ndDec = new Decimal(nD)
            const nDres = ndDec.pow(i);
            const TDec = new Decimal(T)
            const TRes = TDec.pow(j)

            const valNDRes = valDec.mul(nDres)

            // calc = calc + val.value * (nD**i) * (T**j);
            calc = calc + Number(valNDRes.mul(TRes))
        });
    });

    return calc
}

const checkRange = (calculationResults: Array<{label: number, value: number}> ) => {

    let calculationResultsInRange = [...calculationResults]
    let firstPositive = calculationResultsInRange.find((el) => el.value > 0);
    let lastUnderMax = calculationResultsInRange.slice().reverse().find(el => el.value < 100 && el.value > 0);

    if (firstPositive !== undefined && lastUnderMax !== undefined) {
        if (firstPositive.label >= 1.33 && lastUnderMax.label < 1.55) {
            calculationResultsInRange = calculationResultsInRange.filter(obj => obj.label >= 1.32  && obj.label < 1.56)
        }
    }

    return calculationResultsInRange
}

// Calculate RI of water in temperature T
const calcnDw = (T: number = 20.0) => {
    const w0 = new Decimal(1.334338155712060)
    const w1 = new Decimal(-0.000269455746280)
    const w2 = new Decimal(-0.026991418423950)
    const w3 = new Decimal(0.020912809181470)
    const w4 = new Decimal(-0.013787903619690)
    const w5 = new Decimal(0.005233520004590)
    const w6 = new Decimal(-0.000853306109150)

    let Tval = new Decimal (T / 100);

    let w1Res = w0.add(w1.mul(Tval))
    let w2Res = w2.mul(Tval.pow(2))
    let w3Res = w3.mul(Tval.pow(3))
    let w4Res = w4.mul(Tval.pow(4))
    let w5Res = w5.mul(Tval.pow(5))
    let w6Res = w6.mul(Tval.pow(6))
    let total = w1Res.add(w2Res.add(w3Res.add(w4Res.add(w5Res.add(w6Res)))))
    // let water_nD = w0 + w1 * Tval + w2 * Tval**2 + w3 * Tval**3 + w4 * Tval**4 + w5 * Tval**5 + w6 * Tval**6
    const water_nD = Number(total) / 1.00027

    return water_nD

}


export const calculateCurve = (parameter_matrix: any[], T: number, isWaterBased: string = "Yes") => {

    let nD = 0
    let nDw = 0

    if (isWaterBased === "Yes") {
        nDw = calcnDw(T)
        T = T-20.0          // Temperature delta to reference temperature
    }

    let maxnD = 1.76
    let nDValue = 1.26
    let calculationResults: Array<{label: number, value: number}> = []

    while (nDValue < maxnD) {
        if (isWaterBased === "Yes") {
            nD = (nDValue - nDw)*5.0
        } else {
            nD = (nDValue-1)
        }

        let calcResult = sumCalc(nD, parameter_matrix, T)

        calculationResults.push({label: nDValue, value: calcResult});

        nDValue = Math.round((nDValue + 0.001) * 1000) / 1000;
    }

    calculationResults = checkRange(calculationResults)

    return calculationResults;
}

export const calculatePoint = (nD: number = 0, conc: number = 0, parameter_matrix: any[], T: number, isWaterBased: string) => {

    let pointResult = {
        label: 0,
        value: 0
    }

    let nDw = 0
    let nDValue = 0

    if (isWaterBased === "Yes") {
        nDw = calcnDw(T)
        T = T-20.0          // Temperature delta to reference temperature
        nDValue = (nD - nDw) * 5.0;
    } else {
        nDValue = (nD-1)
    }

    pointResult.label = nD;
    pointResult.value = sumCalc(nDValue, parameter_matrix, T);

    return pointResult;
}